
export default {
    name: 'Confirmer',

    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
        isConfirmed: {
            type: Boolean,
            default: false,
        },
        isError: {
            type: Boolean,
            default: false,
        },
        errorText: {
            type: String,
            default: 'labels.cancel',
        },
    },
}
